var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{staticClass:"c-label c-label--green"},[_vm._v("New Label")]),_vm._v(" "),_c('span',{staticClass:"c-label c-label--purple"},[_vm._v("Shop Label")]),_vm._v(" "),_c('span',{staticClass:"c-label c-label--orange"},[_vm._v("Recipes")]),_vm._v(" "),_c('span',{staticClass:"c-label c-label--grey"},[_vm._v("Inactive")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e48f2232","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./demo/ui-kit/labels.vue
// module id = 1090
// module chunks = 0